/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import CUS_Client003 from '@/views/move/cus_client/CUS_Client003/index.vue';
import CUS_Client004 from '@/views/move/cus_client/CUS_Client004/index.vue';

/**
 * Import component of view
 */

const CUS_Register001 = () => import('@/views/move/cus_register/CUS_Register001');
const CUS_Register002 = () => import('@/views/move/cus_register/CUS_Register002');
const CUS_Register003 = () => import('@/views/move/cus_register/CUS_Register003');
const CUS_Register005 = () => import('@/views/move/cus_register/CUS_Register005');

const CUS_Register004 = () => import('@/views/move/cus_register/CUS_Register004');
// const CUS_Order001 = () => import('@/views/move/cus_order/CUS_Order001');
const CUS_Order011 = () => import('@/views/move/cus_order/CUS_Order011');
const CUS_Order012 = () => import('@/views/move/cus_order/CUS_Order012');
const CUS_Order013 = () => import('@/views/move/cus_order/CUS_Order013');
const CUS_Order014 = () => import('@/views/move/cus_order/CUS_Order014');
const CUS_Billing001 = () => import('@/views/move/cus_billing/CUS_Billing001');
const CUS_Start001 = () => import('@/views/move/cus_start/CUS_Start001');
const CUS_Start011 = () => import('@/views/move/cus_start/CUS_Start011');
const CUS_Start002 = () => import('@/views/move/cus_start/CUS_Start002');
const CUS_Start003 = () => import('@/views/move/cus_start/CUS_Start003');
const CUS_Start004 = () => import('@/views/move/cus_start/CUS_Start004');
const CUS_Start005 = () => import('@/views/move/cus_start/CUS_Start005');
const CUS_System001 = () => import('@/views/move/cus_system/CUS_System001');
const CUS_System011 = () => import('@/views/move/cus_system/CUS_System011');
const CUS_System003 = () => import('@/views/move/cus_system/CUS_System003');
const CUS_System002 = () => import('@/views/move/cus_system/CUS_System002');
const CUS_Master001 = () => import('@/views/move/cus_master/CUS_Master001');
const CUS_Master003 = () => import('@/views/move/cus_master/CUS_Master003');
const CUS_Order022 = () => import('@/views/move/cus_order/CUS_Order022');
const CUS_Order023 = () => import('@/views/move/cus_order/CUS_Order023');
const CUS_System003_Detail = () => import('@/views/move/cus_system/CUS_System003_Detail');
const CUS_Order021 = () => import('@/views/move/cus_order/CUS_Order021');
const CUS_Order015 = () => import('@/views/move/cus_order/CUS_Order022');
const CUS_Order016 = () => import('@/views/move/cus_order/CUS_Order016');
const PreviewPdf = () => import('@/views/move/export_pdf_template/PreviewPdf.vue');
const CUS_Master005 = () => import('@/views/move/mng_master/MNG_Master005');

// FAQ
const HelpCenter = () => import('@/views/faq/helpCenter');
const FaqCategories = () => import('@/views/faq/categories');
const Sections = () => import('@/views/faq/categories/sections');
const FaqSearchKeyword = () => import('@/views/faq/searchKeyword');
const FaqArticlesDiagram1 = () => import('@/views/faq/categories/sections/articles/diagram1');
const FaqArticle = () => import('@/views/faq/categories/sections/articles/articleCommon');
const FaqArticlesChangePersonalSettings = () => import('@/views/faq/categories/sections/articles/changePersonalSettings');
const FaqArticlesSurveyEntry = () => import('@/views/faq/categories/sections/articles/surveyEntry');
const FaqArticlesAddStaffMember = () => import('@/views/faq/categories/sections/articles/addStaffMember');
const FaqArticlesStaffLoginSettings = () => import('@/views/faq/categories/sections/articles/staffLoginSettings');
const FaqArticlesAddOrderLocations = () => import('@/views/faq/categories/sections/articles/addOrderLocations');
const FaqArticlesEstimateRequestGuide = () => import('@/views/faq/categories/sections/articles/estimateRequestGuide');
const FaqArticlesConfrimRequestGuide = () => import('@/views/faq/categories/sections/articles/confrimRequestGuide');
const FaqArticlesWorkRequestMethod = () => import('@/views/faq/categories/sections/articles/workRequestMethod');
const FaqArticlesCheckRequestedWorkMethod = () => import('@/views/faq/categories/sections/articles/checkRequestedWorkMethod');
const FaqArticlesChangeOrCancelMethod = () => import('@/views/faq/categories/sections/articles/changeOrCancelMethod');
const FaqArticlesTemplateFeature = () => import('@/views/faq/categories/sections/articles/templateFeature');
const FaqArticlesTroubleAtLogin = () => import('@/views/faq/categories/sections/articles/troubleAtLogin');

const FAQContact = () => import('@/views/faq/cus_contactFAQ');
/**
 * Defined Router
 */
export default [
    {
        path: '/CUS_Register001',
        name: 'CUS_Register001',
        component: CUS_Register001,
        meta: {
            title: 'アンケ―ト',
            layout: 'MainLayout'
        }
    },
    {
        path: '/previewPdf/:file_name?/:path/:type?',
        name: 'PreviewPdf',
        component: PreviewPdf,
        meta: {
            title: '',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/CUS_Register002/:customer_cd?',
        name: 'CUS_Register002',
        component: CUS_Register002,
        meta: {
            title: '会社情報登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Register003/:customer_cd?',
        name: 'CUS_Register003',
        component: CUS_Register003,
        meta: {
            title: '発注拠点情報',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Register004/:customer_cd?',
        name: 'CUS_Register004',
        component: CUS_Register004,
        meta: {
            title: '請求情報',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Register005/:customer_cd?',
        name: 'CUS_Register005',
        component: CUS_Register005,
        meta: {
            title: '受付完了',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Master001',
        name: 'CUS_Master001',
        component: CUS_Master001,
        meta: {
            title: 'テンプレートマスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Master003',
        name: 'CUS_Master003',
        component: CUS_Master003,
        meta: {
            title: '持ち物マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Master005',
        name: 'CUS_Master005',
        component: CUS_Master005,
        meta: {
            title: '現場担当者マスタ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Order011/:order_no?',
        name: 'CUS_Order011',
        component: CUS_Order011,
        meta: {
            title: '新規申込（現場情報）',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Order012/:order_no',
        name: 'CUS_Order012',
        component: CUS_Order012,
        meta: {
            title: '新規申込（新規見積）',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Order013/:order_no/:detail_no?',
        name: 'CUS_Order013',
        component: CUS_Order013,
        meta: {
            title: '新規申込（作業内容）',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Order014/:order_no',
        name: 'CUS_Order014',
        component: CUS_Order014,
        meta: {
            title: '見積登録情報表示',
            layout: 'MainLayout'
        }
    },
    // {
    //     path: '/CUS_Order001',
    //     name: 'CUS_Order001',
    //     component: CUS_Order001,
    //     meta: {
    //         title: '簡単見積',
    //         layout: 'MainLayout'
    //     }
    // },
    {
        path: '/CUS_Delivery001',
        name: 'CUS_Delivery001',
        component: CUS_Billing001,
        meta: {
            title: '納品書',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Billing001',
        name: 'CUS_Billing001',
        component: CUS_Billing001,
        meta: {
            title: '請求書',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_FileDownload001',
        name: 'CUS_FileDownload001',
        component: CUS_Billing001,
        meta: {
            title: 'ファイルダウンロード',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start001/:customer_cd?/:personal_id?',
        name: 'CUS_Start001',
        component: CUS_Start001,
        meta: {
            title: '初回挨拶表示ページ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start011/:personal_id?',
        name: 'CUS_Start011',
        component: CUS_Start011,
        meta: {
            title: '利用規約',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start002/:personal_id?',
        name: 'CUS_Start002',
        component: CUS_Start002,
        meta: {
            title: 'ID/パスワード設定',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start003/:personal_id?',
        name: 'CUS_Start003',
        component: CUS_Start003,
        meta: {
            title: 'お客様利用情報',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start004/:personal_id?',
        name: 'CUS_Start004',
        component: CUS_Start004,
        meta: {
            title: '利用登録完了',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start005/:personal_id?',
        name: 'CUS_Start005',
        component: CUS_Start005,
        meta: {
            title: 'お問い合わせ',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_System001',
        name: 'CUS_System001',
        component: CUS_System001,
        meta: {
            title: 'TOP',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_System011',
        name: 'CUS_System011',
        component: CUS_System011,
        meta: {
            title: 'TOP',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_System003',
        name: 'CUS_System003',
        component: CUS_System003,
        meta: {
            title: '担当者一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_System002/:personal_id?',
        name: 'CUS_System002',
        component: CUS_System002,
        meta: {
            title: '個人設定',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_System003_Detail/:id?',
        name: 'CUS_System003_Detail',
        component: CUS_System003_Detail,
        meta: {
            title: '担当者設定',
            layout: 'MainLayout'
        }
    },
    {
        // path: '/CUS_Order022/:id?/:status_cd?',
        path: '/CUS_Order022/:id?/:status_cd_1?/:status_cd_2?',
        name: 'CUS_Order022',
        component: CUS_Order022,
        meta: {
            title: '申込状況',
            layout: 'MainLayout'
        }
    },
    {
        // path: '/CUS_Order023/:id?/:status_cd?',
        // path: '/CUS_Order023/:id?/:status_cd_1?/:status_cd_2?',
        path: '/CUS_Order023/:order_no?/:detail_no?',
        name: 'CUS_Order023',
        component: CUS_Order023,
        meta: {
            title: '申込詳細',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Order021/:order_no?/:detail_no?',
        name: 'CUS_Order021',
        component: CUS_Order021,
        meta: {
            title: '申込状況検索',
            layout: 'MainLayout'
        }
    },
    {
        // path: '/CUS_Order015/:id?/:status_cd?',
        // path: '/CUS_Order015/:id?/:status_cd_1?/:status_cd_2?',
        path: '/CUS_Order015/:order_no?',
        name: 'CUS_Order015',
        component: CUS_Order015,
        meta: {
            title: '見積詳細確認',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Order016/:button_cd?',
        name: 'CUS_Order016',
        component: CUS_Order016,
        meta: {
            title: '申込完了表示',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Client003',
        name: 'CUS_Client003',
        component: CUS_Client003,
        meta: {
            title: '発注拠点一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Client004/:customer_cd?/:branch_cd?',
        name: 'CUS_Client004',
        component: CUS_Client004,
        meta: {
            title: '発注拠点登録',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start021/:personal_id?/:location_cd?',
        name: 'CUS_Start021',
        component: CUS_Start011,
        meta: {
            title: '利用規約',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start022/:personal_id?',
        name: 'CUS_Start022',
        component: CUS_Register003,
        meta: {
            title: '発注拠点情報',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start023/:personal_id?',
        name: 'CUS_Start023',
        component: CUS_Register004,
        meta: {
            title: '請求情報',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Start024/:customer_cd?',
        name: 'CUS_Start024',
        component: CUS_Register005,
        meta: {
            title: '受付完了',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_Master005',
        name: 'CUS_Master005',
        component: CUS_Master005,
        meta: {
            title: '現場担当者マスタ',
            layout: 'MainLayout'
        }
    },
    // FAQ
    {
        path: '/CUS_FAQ',
        name: 'HelpCenter',
        component: HelpCenter,
        meta: {
            layout: 'FaqLayout',
            layoutProps: {
                headerClass: 'faq-help-center-header'
            }
        }
    },
    {
        path: '/CUS_FAQ/categories/:faq_id',
        name: 'FaqCategories',
        component: FaqCategories,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/sections/:faq_id?',
        name: 'Sections',
        component: Sections,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/searchKeyword',
        name: 'FaqSearchKeyword',
        component: FaqSearchKeyword,
        meta: {
            layout: 'FaqLayout'
        }
    },

    // FAQ - articles
    {
        path: '/CUS_FAQ/articles/diagram1/:faq_id?',
        name: 'diagram1',
        component: FaqArticlesDiagram1,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/change-personal-settings/:faq_id?',
        name: 'FaqArticlesChangePersonalSettings',
        component: FaqArticlesChangePersonalSettings,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/survey-entry/:faq_id?',
        name: 'FaqArticlesSurveyEntry',
        component: FaqArticlesSurveyEntry,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/add-staff-member/:faq_id?',
        name: 'FaqArticlesAddStaffMember',
        component: FaqArticlesAddStaffMember,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/staff-login-settings/:faq_id?',
        name: 'FaqArticlesStaffLoginSettings',
        component: FaqArticlesStaffLoginSettings,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/add-order-locations/:faq_id?',
        name: 'FaqArticlesAddOrderLocations',
        component: FaqArticlesAddOrderLocations,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/estimate-request-guide/:faq_id?',
        name: 'FaqArticlesEstimateRequestGuide',
        component: FaqArticlesEstimateRequestGuide,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/confrim-request-guide/:faq_id?',
        name: 'FaqArticlesConfrimRequestGuide',
        component: FaqArticlesConfrimRequestGuide,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/work-request-method/:faq_id?',
        name: 'FaqArticlesWorkRequestMethod',
        component: FaqArticlesWorkRequestMethod,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/check-requested-work-method/:faq_id?',
        name: 'FaqArticlesCheckRequestedWorkMethod',
        component: FaqArticlesCheckRequestedWorkMethod,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/change-or-cancel-method/:faq_id?',
        name: 'FaqArticlesChangeOrCancelMethod',
        component: FaqArticlesChangeOrCancelMethod,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/template-feature/:faq_id?',
        name: 'FaqArticlesTemplateFeature',
        component: FaqArticlesTemplateFeature,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/trouble-at-login/:faq_id?',
        name: 'FaqArticlesTroubleAtLogin',
        component: FaqArticlesTroubleAtLogin,
        meta: {
            layout: 'FaqLayout'
        }
    },
    {
        path: '/CUS_FAQ/articles/:faq_id?',
        name: 'FaqArticle',
        component: FaqArticle,
        meta: {
            layout: 'FaqLayout'
        }
    },

    // FAQ - お問い合わせ
    {
        path: '/CUS_FAQ/contact',
        name: 'FAQContact',
        component: FAQContact,
        meta: {
            title: 'お問い合わせ',
            layout: 'FaqLayout'
        }
    }
];
